<template>
    <div class="chain-base">
        <router-view/>
        <div v-if="$route.meta.footer.show" class='common-footer-wrap'>
            <mt-tabbar v-model='home_selected' fixed class="common-footer">
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeIndex'}" id='home_index'><router-link :to="{ name: 'HomeIndex'}" class='item'><i class='iconfont icon-homepage' /><span class='text'>Return to the mall</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='ChainOrderList'}" id='chain_order'><router-link :to="{ name: 'ChainOrderList'}" class='item'><i class='iconfont icon-quanbudingdan1' /><span class='text'>Order management</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='ChainIndex'}" id='chain_index'><router-link :to="{ name: 'ChainIndex'}" class='item'><i class='iconfont icon-people' /><span class='text'>Store Center</span></router-link></mt-tab-item>
            </mt-tabbar>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ChainBase',
  data () {
    return {
      home_selected: 'chain_index'
    }
  },
  computed: {
    ...mapState({
      user: state => state.chain.info
    })
  },
  created: function () {
    if (this.$route.name != 'ChainRegister' && this.$route.name != 'ChainLogin' && !this.user) {
      this.$router.push({ name: 'ChainLogin' })
    }
  }
}
</script>
